type SearchValue = string | Array<string>;

export type Query = Record<string, SearchValue>;

export const parseSearch = (search: string): Query => {
  const query: Query = {};
  new URLSearchParams(search).forEach((value, key) => {
    const current = query[key];
    if (current === undefined) query[key] = value;
    else query[key] = ([] as Array<string>).concat(current, value);
  });
  return query;
};

export const stringifySearch = (query: Record<string, unknown>): string => {
  const parts: Array<string> = [];
  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    ([] as Array<unknown>).concat(value).forEach((v) => {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(v))}`);
    });
  });
  return parts.length ? `?${parts.join('&')}` : '';
};
